import type { Meter } from '@vy/types';

export function filterMetersByEventNames(meters: Meter[], eventNames: string[]) {
  return meters.filter((meter) => eventNames.includes(meter.eventName));
}
